import { proxyCustomElement, HTMLElement, h, Host } from '@stencil/core/internal/client';

const onvioLoaderCss = ".Ov-loader{display:block;text-align:center}.sr-only{height:1px;left:-10000px;overflow:hidden;position:absolute;top:auto;width:1px}.d-flex{display:flex}.Ov-loading-circle{opacity:25%}";

const OnvioLoader = /*@__PURE__*/ proxyCustomElement(class extends HTMLElement {
  constructor() {
    super();
    this.__registerHost();
    this.__attachShadow();
    this.size = '40px';
    this.loading = false;
    this.color = '#fa6400ff';
    this.disabled = false;
    this.loadingText = undefined;
  }
  getLoadingSpinner() {
    if (this.disabled) {
      return (h("div", null, h("saf-icon", { size: this.size, class: "d-flex", "aria-hidden": "true", "icon-data": `<svg viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
						<g>
						<circle fill='none' stroke-width='6' cx='33' cy='33' r='30'stroke='#fff' class="Ov-loading-circle"/>
						<animateTransform attributeName="transform" type="rotate" values="0 33 33;270 33 33" begin="0s" dur="1.4s" fill="freeze" repeatCount="indefinite"/>
						<circle fill="none" stroke-width="6" stroke-linecap="square" cx="33" cy="33" r="30" stroke-dasharray="187" stroke-dashoffset="610">
						<animate attributeName="stroke" values="#fff" begin="0s" dur="5.6s" fill="freeze" repeatCount="indefinite"/>
						<animateTransform attributeName="transform" type="rotate" values="0 33 33;135 33 33;450 33 33" begin="0s" dur="1.4s" fill="freeze" repeatCount="indefinite"/>
						<animate attributeName="stroke-dashoffset" values="187;46.75;187" begin="0s" dur="1.4s" fill="freeze" repeatCount="indefinite"/>
						</circle>
						</g>
						</svg>` })));
    }
    return (h("div", null, h("saf-icon", { size: this.size, class: "d-flex", "aria-hidden": "true", "icon-data": `<svg viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
						<g>
						<circle fill='none' stroke-width='6' cx='33' cy='33' r='30'stroke='#1f1f1f' class="Ov-loading-circle"/>
						<animateTransform attributeName="transform" type="rotate" values="0 33 33;270 33 33" begin="0s" dur="1.4s" fill="freeze" repeatCount="indefinite"/>
						<circle fill="none" stroke-width="6" stroke-linecap="square" cx="33" cy="33" r="30" stroke-dasharray="187" stroke-dashoffset="610">
						<animate attributeName="stroke" values=${this.color} begin="0s" dur="5.6s" fill="freeze" repeatCount="indefinite"/>
						<animateTransform attributeName="transform" type="rotate" values="0 33 33;135 33 33;450 33 33" begin="0s" dur="1.4s" fill="freeze" repeatCount="indefinite"/>
						<animate attributeName="stroke-dashoffset" values="187;46.75;187" begin="0s" dur="1.4s" fill="freeze" repeatCount="indefinite"/>
						</circle>
						</g>
						</svg>` })));
  }
  render() {
    if (this.loading) {
      return (h(Host, null, h("slot", null, h("div", { class: "Ov-loader", "aria-live": "polite", "aria-atomic": "true" }, h("div", { class: "Ov-loader-container", "aria-labelledby": "loadingText" }, this.getLoadingSpinner())), h("div", { id: "loadingText", class: "sr-only" }, this.loadingText))));
    }
  }
  static get style() { return onvioLoaderCss; }
}, [1, "onvio-loader", {
    "size": [1],
    "loading": [4],
    "color": [1],
    "disabled": [4],
    "loadingText": [1, "loading-text"]
  }]);
function defineCustomElement() {
  if (typeof customElements === "undefined") {
    return;
  }
  const components = ["onvio-loader"];
  components.forEach(tagName => { switch (tagName) {
    case "onvio-loader":
      if (!customElements.get(tagName)) {
        customElements.define(tagName, OnvioLoader);
      }
      break;
  } });
}

export { OnvioLoader as O, defineCustomElement as d };

